import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
  templates: [],
  response: [],
  referenceNos: [],
  allUserNames: [],
  isFetching: false,
  isSuccess: false,
  isResponse: false,
  isAddResponse: false,
  isUsersNameSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getTemplatesAsyn = createAsyncThunk(
  'document/getTemplates',
  async (udata = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;

      const response = await axios.get('/api/DDsAndAds/templates', { headers: { "Authorization": `Bearer ${tokenStr}` } });

      //   let response = await axios({
      //     url: '/api/detailedDepartment/deptType/',
      //     method: 'get',
      //     data:udata,
      //     //timeout: 8000,
      //     headers: {
      //         //'Content-Type': 'application/json',
      //         "Authorization" : `Bearer ${tokenStr}`
      //     }
      // })

      let data = response.data;

      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const AddDocumentSlice = createSlice({
  name: 'DDsAndAdsadddocument',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateSlice: (state, { payload }) => {
      state.templates = [];
      state.response = [];
      state.isError = false;
      state.isSuccess = false;
      state.isResponse = false;
      state.isAddResponse = false;
      state.errorMessage = '';
    },
    setAddState: (state, { payload }) => {
      state.isAddResponse = true;
      state.response = payload.data;
    },
    usetsetAddState: (state, { payload }) => {
      state.isAddResponse = false;
    },
    setReferenceNoState: (state, { payload }) => {
      // console.log(payload)
      state.isResponse = true;
      state.referenceNos = payload.data.data;
    },
    setResponseState: (state, { payload }) => {
      state.isResponse = true;
    },
    unSetResponseState: (state, { payload }) => {
      state.isResponse = false;
    },
    setUsersNameState: (state, { payload }) => {
      state.isUsersNameSuccess = true;
      state.allUserNames = payload.data.users;
    },
    clearUsersNameState: (state, { payload }) => {
      state.isUsersNameSuccess = false;
      state.allUserNames = [];
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getTemplatesAsyn.fulfilled]: (state, { payload }) => {
      state.templates = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = payload.message;
      return state;
    },
    [getTemplatesAsyn.pending]: (state) => {
      state.isFetching = true;
    },
    [getTemplatesAsyn.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateSlice, clearUsersNameState, setResponseState, unSetResponseState, setAddState, usetsetAddState, setReferenceNoState, setUsersNameState } = AddDocumentSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateSlice());
  }
}

export function responseState() {

  return async (dispatch) => {
    dispatch(setResponseState());
  }
}

export function clearResponseState() {

  return async (dispatch) => {
    dispatch(unSetResponseState());
  }
}

export function clearAddResponseState() {

  return async (dispatch) => {
    dispatch(usetsetAddState());
  }
}

export function clearAllUsersNameState() {

  return async (dispatch) => {
    dispatch(clearUsersNameState());
  }
}


export const adddocumentSelector = (state) => state.DDsAndAdsadddocument;

export const AddDocumentAsyn = (bdata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.post('/api/DDsAndAds/addDocument', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  //console.log(data.data)
  dispatch(setAddState(data));
  return data;
};

export const getReferenceNoAsyn = () => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.get('/api/DDsAndAds/referenceNumber', { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  // console.log('DDsAndAds ref', data)
  dispatch(setReferenceNoState(data));
  return data;
};

export const getUsersNameAsyn = () => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.get('/api/DDsAndAds/template/allUsers?limit=1000', { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  dispatch(setUsersNameState(data));
  return data;
};


// export const addModuleAsyn = (bdata) => async (dispatch, getState) => {
//   try {
//   const { auth } = getState()
//    let tokenStr = auth.user.token;
//    const response = await axios.patch('/api/department/addDeptType',bdata, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

//     let data = response.data;
//     return data;
//   } catch (error) {
//     return error.response.data;
//   }
// };




export default AddDocumentSlice.reducer;
